export default "__VITE_PUBLIC_ASSET__bac6327d__"